import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { MenuScheduleApiService } from 'app/services/menu-schedule.api.service';
import { MatTableDataSource } from '@angular/material/table';
import {  MenuScheduleModalItem } from 'app/models/menu.schedule.model';
import { IBaseResponse } from 'app/models/baseResponse.model';

@Component({
  selector: 'app-menu-schedules-entity-modal',
  templateUrl: './menu-schedules-entity-modal.component.html',
  styleUrls: ['./menu-schedules-entity-modal.component.scss']
})
export class MenuSchedulesEntityModalComponent implements OnInit {
  menuSectionId: string;
  entityId: string; // в зависимости от конфигурации компонента, это поле соответствует externalProductId или groupId.
  initialEntityIds: string[];
  entityType: MenuSchedulesEntityType;
  dataSource = new MatTableDataSource<MenuScheduleModalItem>([]);

  constructor(
    private dialogRef: MatDialogRef<MenuSchedulesModalData>,
    private translate: TranslateService,
    private menuScheduleApiService: MenuScheduleApiService,
    @Inject(MAT_DIALOG_DATA) public data: MenuSchedulesModalData,
  ) { }

  async ngOnInit() {
    this.menuSectionId = this.data.menuSectionId;
    this.entityId = this.data.entityId;
    this.entityType = this.data.entityType;

    const responseMenuSchedules = await this.menuScheduleApiService.getSchedules(this.menuSectionId);
    const responseEntitySchedules = this.entityType === MenuSchedulesEntityType.PRODUCT ?
      await this.menuScheduleApiService.getProductSchedules(this.menuSectionId, this.entityId):
      await this.menuScheduleApiService.getGroupSchedules(this.menuSectionId, this.entityId);
    this.initialEntityIds = responseEntitySchedules.data.menuScheduleIds;

    let modalItems: MenuScheduleModalItem[] = [];
    for (let responseMenuSchedule of responseMenuSchedules.data) {
      if (responseMenuSchedule.allMenu){
        continue;
      }

      modalItems.push({
        menuScheduleId: responseMenuSchedule.id,
        dayOfWeek: responseMenuSchedule.dayOfWeek,
        from: responseMenuSchedule.from,
        to: responseMenuSchedule.to,
        name: responseMenuSchedule.name,
        isActiveMenuSchedule: responseMenuSchedule.isActive,
        isActiveEntitySchedule: this.initialEntityIds.some(id => id === responseMenuSchedule.id),
      })
    }

    this.dataSource = new MatTableDataSource<MenuScheduleModalItem>(modalItems);
  }

  columnsToDisplay = ['dayOfWeek', 'from', 'to', 'name', 'isActiveMenuSchedule', 'isActiveEntitySchedule'];
  getColumnHeaderName(columnHeaderValue: string): string {
    switch (columnHeaderValue) {
      case 'dayOfWeek':
        return this.translate.instant('MENU.DAY_OF_WEEK');
      case 'from':
        return this.translate.instant('MENU.FROM');
      case 'to':
        return this.translate.instant('MENU.TO');
      case 'name':
        return this.translate.instant('COMMON.NAME');
      case 'isActiveMenuSchedule':
        return this.translate.instant('MENU.IS_ACTIVE_FOR_ALL_MENU_SCHEDULE');
      case 'isActiveEntitySchedule':
        return this.translate.instant('COMMON.IS_ACTIVE');
    }
  }

  changeIsActive(menuScheduleId: string, checked: boolean) {
    this.dataSource.data
      .find(s => s.menuScheduleId === menuScheduleId)
      .isActiveEntitySchedule = checked;
  }

  async saveAllAsync() {
    const selectedScheduleIds = this.dataSource.data.filter(s => s.isActiveEntitySchedule)
      .map(s => s.menuScheduleId);

    let response: IBaseResponse<any> = null;

    if (this.entityType === MenuSchedulesEntityType.PRODUCT){
      response = await this.menuScheduleApiService.setProductSchedules({
        menuSectionId: this.menuSectionId,
        externalProductId: this.entityId,
        menuScheduleIds: selectedScheduleIds,
      });
    }
    else{
      response = await this.menuScheduleApiService.setGroupSchedules({
        menuSectionId: this.menuSectionId,
        groupId: this.entityId,
        menuScheduleIds: selectedScheduleIds,
      });
    }

    if(response.success){
      this.dialogRef.close();
    }
    else{
      alert("error");
    }
  }

  hasChanges(){
    const selectedScheduleIds = this.dataSource.data.filter(s => s.isActiveEntitySchedule)
      .map(s => s.menuScheduleId);

    return JSON.stringify(this.initialEntityIds) !== JSON.stringify(selectedScheduleIds);
  }

  exit() {
    this.dialogRef.close();
  }

}

export interface MenuSchedulesModalData {
  menuSectionId: string;
  entityId: string; // в зависимости от конфигурации компонента, это поле соответствует externalProductId или groupId.
  entityType: MenuSchedulesEntityType,
}

export enum MenuSchedulesEntityType {
  PRODUCT,
  GROUP,
}
